const translations = {
  "en": {
    "· Clicking 'Pay now' confirms your agreement to our": "· Clicking 'Pay now' confirms your agreement to our",
    "and": "and",
    "Approve and pay": "Approve and pay",
    "Pay now": "Pay now",
    "Privacy Policy": "Privacy Policy",
    "Terms of Service": "Terms of Service",
    "User rejected the approve.": "User rejected the approve."
  },
  "zh-tw": {
    "· Clicking 'Pay now' confirms your agreement to our": "· 點擊「立即支付」即表示你同意我們的",
    "and": "和",
    "Approve and pay": "授權並支付",
    "Pay now": "立即支付",
    "Privacy Policy": "隱私權政策",
    "Terms of Service": "服務條款",
    "User rejected the approve.": "使用者拒絕授權。"
  }
};

export default translations;
